import { gql } from 'graphql-request';

export default gql`
  mutation updateVmboxMessageCustomFieldById($data: JSON) {
    updateVmboxMessageCustomFieldById(data: $data) {
      success
      message
      data
    }
  }
`;
